import {AsiDialogView} from "@asi-ngtools/lib";
import {EtatEmissionEnums} from "./../../enum/EtatEmission.enum";
import {Observable} from "rxjs/Rx";
import {HprimFaxDto, HprimFaxMedecin, IEmissionWebServiceClient} from "@resources/resources";
import {Component} from "@angular/core";
import * as lodash from "lodash";
import { UserStore } from "@digicerba/common";

@Component({
  selector: 'dialog-hprim',
  templateUrl: './dialog-hprim-fax.component.html'
})
export class HprimFaxDialog extends AsiDialogView {

  dossiers: Array<HprimFaxMedecin>;
  commence: boolean = false;
  termine: boolean = false;
  hprim: boolean = false;
  reemissionType: string = null;
  dossiersConnectHprim: Array<string>;

  traitementHprimFinished: boolean = false;

  constructor(private emissionWebService: IEmissionWebServiceClient, userStore: UserStore) {
    super();
    emissionWebService.isHprimInTags().subscribe(
      data => this.hprim = data
    );
  }

  ngAfterContentInit() {
    this.dossiers.forEach(d => {
      d.hprimFaxDto.exemplaireMedecin = false;
    });

    this.traitementHprimFinished = false;
    this.emissionWebService.estConnecteHprim(this.dossiers.map(d => d.hprimFaxDto)).subscribe(data => {
      this.dossiersConnectHprim = data;
      if (data) {
        this.traitementHprimFinished = true;
      }
    });
  }

  /**
   * Réémission Hprim
   */
  reemettreHprim() {
    this.termine = false;

    let dossiersAlter = this.dossiers.map(dossier => dossier.hprimFaxDto).filter(d => (this.dossiersConnectHprim.indexOf(d.numDossier) !== -1));

    this.emissionWebService.hprim(dossiersAlter).subscribe(queueId => {
      dossiersAlter.forEach(d => {
        d.etat = EtatEmissionEnums.EN_COURS.value();
      });
      this.commence = true;
      let timer = Observable.interval(1000).subscribe(() => {
        this.emissionWebService.etat(queueId).subscribe(emissions => {
          emissions.forEach(emission => {
            let e = lodash.find(dossiersAlter, function (o: HprimFaxDto) {
              return o.numDossier == emission.numDossier;
            });
            e.etat = emission.etat;
          });
        });
        if (this.isTermine()) {
          timer.unsubscribe();
          this.termine = true;
        }
      })
    });
    this.reemissionType = "HPRIM";
  }

  /**
   * Réémission Fax
   */
  reemettreFax() {
    this.termine = false;

    let dossiersAvecFax: Array<HprimFaxDto> = lodash.filter(this.dossiers.map(dossier => dossier.hprimFaxDto), function (o: HprimFaxDto) {
      return o.numFax || lodash.trim(o.numFax);
    });

    this.emissionWebService.fax(dossiersAvecFax).subscribe(queueId => {
      dossiersAvecFax.forEach(d => {
        d.etat = EtatEmissionEnums.EN_COURS.value();
      });
      this.commence = true;
      let timer = Observable.interval(1000).subscribe(() => {
        this.emissionWebService.etat(queueId).subscribe(emissions => {
          emissions.forEach(emission => {
            let e = lodash.find(dossiersAvecFax, function (o: HprimFaxDto) {
              return o.numDossier == emission.numDossier;
            });
            e.etat = emission.etat;
          });
        });
        if (this.isTermine()) {
          timer.unsubscribe();
          this.termine = true;
        }
      })
    });
    this.reemissionType = "FAX";
  }

  /**
   * Test si la réémission du dossier est terminée
   * @returns {boolean}
   */
  isTermine() {
    let termine = lodash.find(this.dossiers, function (o) {
      return o.hprimFaxDto.etat == EtatEmissionEnums.EN_COURS.value();
    });
    return termine == undefined;
  }

  /**
   * Test pour l'affichage du boutton de réémission par fax
   * @returns {boolean}
   */
  isValidFax() {
    let nbFax = 0;
    this.dossiers.forEach(d => {
      if (d.hprimFaxDto.numFax || lodash.trim(d.hprimFaxDto.numFax)) {
        nbFax++;
      }
    });

    return nbFax > 0;
  }

  /**
   * Test pour l'affichage du boutton de réémission Hprim
   * @returns {boolean}
   */
  isValidHprim() {
    return this.dossiersConnectHprim != undefined
        && this.dossiers != undefined
      && this.dossiers.filter(d => (this.dossiersConnectHprim.indexOf(d.hprimFaxDto.numDossier) !== -1)).length > 0;
  }

  /**
   *
   * @param numDossier
   * @returns {boolean|any}
   */
  isConnectHprim(numDossier: string) {
    return this.dossiersConnectHprim != undefined && (this.dossiersConnectHprim.indexOf(numDossier) !== -1)
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/dialog/dialog-hprim-fax.component.ts